import { render, staticRenderFns } from "./withdrawLeaveDetails.vue?vue&type=template&id=8009a864&scoped=true&"
import script from "./withdrawLeaveDetails.vue?vue&type=script&lang=js&"
export * from "./withdrawLeaveDetails.vue?vue&type=script&lang=js&"
import style0 from "./withdrawLeaveDetails.vue?vue&type=style&index=0&id=8009a864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8009a864",
  null
  
)

export default component.exports